import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const customFontSize = '14px';

const rowStyle = {
  fontSize: customFontSize,
  color: colors.black,
  fontWeight: fonts.weights.normal,
  letterSpacing: '0.25px',
  lineHeight: '20px',
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  iconButtonContainer: {
    padding: 0,
  },
  summary: {
    backgroundColor: colors.planningGridAccordionSumaryBg,
    minHeight: '72px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  buttonsActionsContainer: {
    display: 'flex',
    width: '100%',
    minHeight: '52px',

    '& .MuiButton-text': {
      fontSize: customFontSize,
      fontWeight: fonts.weights['extra-bold'],
      letterSpacing: '1.25px',
      lineHeight: '16px',
    },
  },
  buttonsActionsContainerRight: {
    justifyContent: 'flex-end',
    display: 'flex',
    width: '100%',
    '& .MuiButton-text': {
      fontSize: customFontSize,
      fontWeight: fonts.weights['extra-bold'],
      letterSpacing: '1.25px',
      lineHeight: '16px',
    },
    '& .MuiSvgIcon-colorPrimary': {
      color: colors.primary,
    },
  },

  container: {
    background: colors.white,
    width: '100%',

    '& .MuiTable-root': {
      borderCollapse: 'collapse',
    },
    // Table root
    '& > div:first-child': {
      minHeight: '200px',
      paddingBottom: '16px',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      background: '#fff',
      zIndex: 999,
      boxShadow:
        'inset 0 1px 0 1px solid rgba(224, 224, 224, 1), inset 0 -1px 0 1px solid rgba(224, 224, 224, 1)',
    },
    // Table container
    '& > div:first-child > div': {
      width: '100%',
      maxHeight: '70vh',
      overflowY: 'auto',
      overflowX: 'hidden',
    },

    '& .MuiTableCell-root': {
      ...rowStyle,
      maxHeight: '64px',
      wordWrap: 'break-word',
    },
    '& .Mui-checked': {
      color: colors.primary,
    },
  },
  selectedRows: {
    backgroundColor: colors.primary02,
    borderLeft: `1px solid ${colors.primary}`,
  },
  disabledRow: {
    '& .MuiTableCell-root': {
      color: colors.darkGray,
    },
  },
  tableTitle: {
    fontSize: customFontSize,
    color: colors.black,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  tooltipLabel: {
    ...rowStyle,
    color: colors.white,
  },
  buttonsActionsContainerLeft: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    '& .MuiTypography-root': {
      color: colors.trueBlack,
      letterSpacing: '0.15px',
      fontSize: '20px',
      padding: '15px',
    },
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  scrollDiv: {
    width: '100%',
    overflowX: 'auto',
  },
  hiddenScrollDiv: {
    height: '1px',
  },
  iconButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default useStyles;
